/* global MEDIA_ROOT */

import React, { PropTypes } from 'react';

import { srOnly } from '../../base-styles/mixins.module.css';
import { ellipsis, ellipsisContainer } from './styles.module.css';

const LoadingEllipsis = ({ htmlTag }) => (
  <div className={ellipsisContainer}>
    {htmlTag === 'h1' ?
      <h1 className={srOnly}>{'Loading'}</h1>
    :
      <p className={srOnly}>{'Loading'}</p>
    }
    <img alt="loading" src={`${MEDIA_ROOT}/icons/loading-small.gif`} className={ellipsis} />
  </div>
);

export default LoadingEllipsis;

LoadingEllipsis.propTypes = {
  /**
   * Render 'Loading' text as `<h1>` or `<p>` tag.
   */
  htmlTag: PropTypes.string,
};

LoadingEllipsis.defaultProps = {
  htmlTag: undefined,
};



// WEBPACK FOOTER //
// ./app/src/components/LoadingEllipsis/index.jsx